import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-get-donations',
    templateUrl: './get-donations.component.html',
    styleUrls: ['./get-donations.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class GetDonationsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
